import { useAppStore } from '@store'

const MSG_KEY_PATTERN = /^MSG_\d+$/

/**
 * - Si `detail` es una clave MSG (ej. MSG_165) → traduce con el catálogo i18n.
 * - Si es texto plano (ej. "Usuario pendiente de validar") → se muestra tal cual llega.
 */
export function translateApiError(detail?: string | null, fallback = ''): string {
  if (!detail) return fallback

  const trimmed = detail.trim()
  if (!MSG_KEY_PATTERN.test(trimmed)) {
    return detail
  }

  const t = useAppStore.getState().t
  return t(trimmed) || detail
}
